<template>
  <div
    style="inline-size: max-content;"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
  >
    <v-menu v-if="showDelete">
      <template v-slot:activator="{ on }">
        <v-slide-x-reverse-transition>
          <v-btn v-show="goHover" v-on="on" icon small color="white" class="red mx-1">
            <v-tooltip bottom open-delay="200">
              <template v-slot:activator="{ on: onTip }">
                <oh-v-icon
                  scale="0.9"
                  name="md-delete"
                  @mouseenter="onTip.mouseenter"
                  @mouseleave="onTip.mouseleave"
                />
              </template>
              <span>Delete</span>
            </v-tooltip>
          </v-btn>
        </v-slide-x-reverse-transition>
      </template>
      <v-card class="pa-2">
        <v-row no-gutters>
          <v-col class="pt-1 pr-2">
            <oh-v-icon name="md-warning"></oh-v-icon>
            Delete For-Reals?
          </v-col>
          <v-btn small color="orange" @click="$emit('delete')">
            Yes
          </v-btn>
          <v-btn small color="grey" text>
            Cancel
          </v-btn>
        </v-row>
      </v-card>
    </v-menu>
    <v-slide-x-reverse-transition v-if="showMakeCard">
      <v-btn
        v-show="goHover"
        icon
        small
        color="white"
        class="green mx-1"
        @click.exact="$emit('makeCard')"
        v-tooltip="{ content: 'Archive', delay: { show: 500, hide: 0 } }"
      >
        <v-tooltip bottom open-delay="200">
          <template v-slot:activator="{ on }">
            <oh-v-icon
              name="md-movetoinbox"
              @mouseenter="on.mouseenter"
              @mouseleave="on.mouseleave"
              scale="0.9"
            ></oh-v-icon>
          </template>
          <span>Archive</span>
        </v-tooltip>
      </v-btn>
    </v-slide-x-reverse-transition>
    <v-slide-x-reverse-transition v-if="showMakeCard">
      <v-btn
        v-show="goHover"
        icon
        small
        color="white"
        class="green mx-1"
        @click.exact="$emit('hide')"
        v-tooltip="{ content: 'Hide', delay: { show: 500, hide: 0 } }"
      >
        <oh-v-icon
          name="md-visibilityoff"
          scale="0.9"
        ></oh-v-icon>
      </v-btn>
    </v-slide-x-reverse-transition>
    <v-slide-x-reverse-transition v-if="showRemove && !dragSelectedMenu">
      <v-btn
        v-show="goHover"
        icon
        v-tooltip="{ content: 'Remove', delay: { show: 500, hide: 0 } }"
        small
        color="white"
        class="green mx-1"
        @click.exact="$emit('remove')"
      >
        <v-tooltip bottom open-delay="200">
          <template v-slot:activator="{ on }">
            <oh-v-icon
              name="md-removecircleoutline"
              @mouseenter="on.mouseenter"
              @mouseleave="on.mouseleave"
              scale="0.9"
            ></oh-v-icon>
          </template>
          <span>Remove from Here</span>
        </v-tooltip>
      </v-btn>
    </v-slide-x-reverse-transition>
    <v-slide-x-reverse-transition v-if="showAddToMyPanel">
      <v-btn
        v-show="goHover"
        icon
        small
        color="white"
        class="pink mx-1"
        v-tooltip="{ content: 'Add to My Panel', delay: { show: 500, hide: 0 } }"
        @click.exact="$emit('addToMyPanel')"
      >
        <v-tooltip bottom open-delay="200">
          <template v-slot:activator="{ on }">
            <oh-v-icon
              name="md-add"
              @mouseenter="on.mouseenter"
              @mouseleave="on.mouseleave"
              scale="0.9"
            ></oh-v-icon>
          </template>
          <span>Add to My Panel</span>
        </v-tooltip>
      </v-btn>
    </v-slide-x-reverse-transition>
    <v-slide-x-reverse-transition v-if="!defaultOpenPane && !dragSelectedMenu">
      <v-btn
        v-show="goHover"
        v-tooltip="{ content: 'Open to Side', delay: { show: 500, hide: 0 } }"
        icon
        small
        color="white"
        class="blue lighten-1 mx-1"
        @click.exact="$emit('openNewPane')"
      >
        <v-tooltip bottom open-delay="200">
          <template v-slot:activator="{ on }">
            <oh-v-icon
              name="ri-layout-column-fill"
              @mouseenter="on.mouseenter"
              @mouseleave="on.mouseleave"
              scale="0.9"
            ></oh-v-icon>
          </template>
          <span>Open to the Side</span>
        </v-tooltip>
      </v-btn>
    </v-slide-x-reverse-transition>
    <v-btn
      v-if="dragSelectedMenu"
      v-tooltip="{ content: 'Group', delay: { show: 500, hide: 0 } }"
      class="purple"
      color="white"
      icon
      small
      @click.exact.stop="$emit('groupSelected')"
    >
      <oh-v-icon scale="0.8" name="md-fitscreen"></oh-v-icon>
    </v-btn>
    <v-btn
      v-else-if="defaultOpenPane"
      class="hover-only blue"
      color="white"
      icon
      small
      @click.exact.stop="$emit('openNewPane')"
      @mousedown.middle.prevent.stop="$emit('openNewTab')"
    >
      <oh-v-icon scale="1.1" name="ri-layout-column-fill"></oh-v-icon>
    </v-btn>
    <v-btn
      v-else
      v-tooltip="{ content: 'Open', delay: { show: 500, hide: 0 } }"
      class="hover-only blue"
      color="white"
      icon
      small
      @click.exact.stop="$emit('open')"
      @click.ctrl.exact.stop="$emit('openNewTab')"
      @click.ctrl.shift.stop="$emit('openNewPane')"
      @click.meta.exact.stop="$emit('openNewTab')"
      @click.meta.shift.stop="$emit('openNewPane')"
      @mousedown.middle.prevent.stop="$emit('openNewTab')"
    >
      <oh-v-icon scale="1.1" name="md-arrowcircleup" style="transform: rotate(90deg)"></oh-v-icon>
    </v-btn>
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api';
export default {
  components: {},
  props: [
    'showDelete',
    'showRemove',
    'showMakeCard',
    'showHide',
    'defaultOpenPane',
    'showAddToMyPanel',
    'dragSelectedMenu'
  ],
  setup(props, { emit }) {
    const log = e => {
      console.log(e);
    };
    const hovering = ref(false);

    const goHover = ref(false);

    watch(hovering, current => {
      console.log(current);
      if (current) {
        console.log('hover start');
        setTimeout(() => {
          if (hovering.value) {
            console.log('hover set true');
            goHover.value = true;
            emit('hoverStart');
          } else {
            goHover.value = false;
            emit('hoverStop');
          }
        }, 400);
      } else {
        console.log('mouse out');
        goHover.value = false;
        emit('hoverStop');
      }
    });
    return { log, hovering, goHover };
  }
};
</script>

<style></style>
